import { conflictResolveType } from '@/workerProcessRenderer/scripts/CoSyncEngine/common/ConflictData';
import { Tree } from '@/workerProcessRenderer/scripts/CoSyncEngine/Tree';

export enum SyncOperationType {
  DWONLOAD = 'download',
  UPLOAD = 'upload',
  CREATE_LOCAL_FOLDER = 'createLocalFolder',
  CREATE_REMOTE_FOLDER = 'createRemoteFolder',
  DELETE_REMOTE = 'deleteRemote',
  DELETE_LOCAL = 'deleteLocal',
  DELETE_REMOTE_FOLDER = 'deleteRemoteFolder',
  DELETE_LOCAL_FOLDER = 'deleteLocalFolder',
  DELETE_REMOTE_IGNORED_EXIT = 'deleteRemoteIgnoredExit',
  DELETE_LOCAL_IGNORED_EXIT = 'deleteLocalIgnoredExit',
  MOVE_LOCAL = 'moveLocal',
  MOVE_REMOTE = 'moveRemote',
  MOVE_LOCAL_FOLDER = 'moveLocalFolder',
  MOVE_REMOTE_FOLDER = 'moveRemoteFolder',
  UPDATE_TREE_NODE = 'updateTreeNode',
  DELETE_TREE_NODE = 'deleteTreeNode',
  MOVE_TREE_NODE = 'moveTreeNode',
  RNAME_LOCAL = 'renameLocal',
  RNAME_LOCAL_FOLDER = 'renameLocalFolder',
  RNAME_REMOTE = 'renameRemote',
  RNAME_REMOTE_FOLDER = 'renameRemoteFolder',
  SKIP_INVALID_FILENAME = 'skipInvalidFileName',
}

export interface BaseOperationItem {
  operation: SyncOperationType;
  path: string; // 相对路径
  srcPath?: string; // 源路径（相对路径，move才有)
  asyncAction?: boolean; // 异步操作该值为true，非异步操作该值为undefind
  dontUpdateSyncTree?: boolean; // 该操作是否需要更新syncTree, true为不需要更新，其他则需要(单向同步时不需要关注其中一端的变更，例如单向上传不需要关注远端的变更)
  conflictResolveChoose?: conflictResolveType; // 若有冲突解决选择，则该值为选择的值，否则为undefind
}

export interface SyncOperationItem extends BaseOperationItem {
  localInfo?: Tree.TreeNode; // 本地文件信息
  remoteInfo?: Tree.TreeNode; // 远端文件信息
  syncNode?: Tree.SyncTreeNode; // 同步树节点
}

export interface OperationItem extends BaseOperationItem {
  localInfo?: Tree.LocalTreeNode; // 本地文件信息
  remoteInfo?: Tree.RemoteTreeNode; // 远端文件信息
  syncNode?: Tree.SyncTreeNode; // 同步树节点
}

export type OperatePath = string; // 操作路径，格式：remote:relativePath、local:relativePath

export function isInnerType(type: SyncOperationType) {
  if (type === SyncOperationType.UPDATE_TREE_NODE) {
    return true;
  }
  if (type === SyncOperationType.DELETE_TREE_NODE) {
    return true;
  }
  if (type === SyncOperationType.MOVE_TREE_NODE) {
    return true;
  }
  return false;
}
